import React from 'react';
import DocumentTemplate from './DocumentTemplate';

/**
 * Order document — delegates to the unified DocumentTemplate.
 * Maintains backward compatibility with existing props: { title, partyLabel, data, docType }
 * Maps the old data shape to the new DocumentTemplate format.
 */
export default function OrderDocument({ title, partyLabel, data, docType = 'estimate' }) {
  const d = data || {};

  // Map docType
  const templateDocType = docType === 'purchase-invoice' ? 'bill'
    : docType === 'sales-order' ? 'sales-order'
    : docType === 'purchase-order' ? 'purchase-order'
    : 'estimate';

  // Map data to the new format
  const mapped = {
    ...d,
    // Number fields
    invoice_number: d.number,
    estimate_number: d.number,
    order_number: d.number,
    po_number: d.number,
    bill_number: d.number,
    // Date fields
    invoice_date: d.date,
    estimate_date: d.date,
    order_date: d.date,
    bill_date: d.date,
    // Expiration / due
    expiration_date: d.second,
    due_date: d.second,
    // Party fields
    customer_name: d.party_name,
    customer_email: d.party_email,
    customer_phone: d.party_phone,
    customer_address: d.party_address,
    customer_company_name: d.party_name,
    vendor_name: d.party_name,
    vendor_email: d.party_email,
    vendor_phone: d.party_phone,
    vendor_address: d.party_address,
    vendor_company_name: d.party_name,
  };

  return <DocumentTemplate docType={templateDocType} data={mapped} />;
}
